import PropTypes from 'prop-types'
import React, { useState } from 'react'
import { connect, shallowEqual, useDispatch, useSelector } from 'react-redux'
import i18n from 'simple-react-i18n'
import CartographyPanel from '../../../components/map/CartographyPanel'
import CMSCategoryDto from '../../../events/dto/CMSCategoryDto'
import CMSEventDto from '../../../events/dto/CMSEventDto'
import { getCmsMarker } from '../../../utils/CmsUtils'
import { getFullDate } from '../../../utils/DateUtil'
import { Button, Dialog, DialogActions, DialogContent, Grid, Typography } from '@mui/material'
import { DefaultDialogTitle } from 'components/styled/Dialog'
import { setConfirmationModal } from 'utils/FormUtils'
import CmsAction from 'events/actions/CmsAction'
import { STATUS } from 'events/constants/CMSEventConstants'
import moment from 'moment'
import ToastrAction from 'toastr/actions/ToastrAction'
import Select from 'components/forms/Select'
import { push } from '@lagunovsky/redux-react-router'

const AlertCmsModal = ({
    cms = {},
    isOpen = false,
    setIsOpen = () => {},
}) => {
    const {
        cmsCategories,
        accountUser,
        sandreCodes,
    } = useSelector(store => ({
        cmsCategories: store.EventsReducer.cmsCategories,
        accountUser: store.AccountReducer.accountUser,
        sandreCodes: store.ReferencialReducer.sandreCodes,
    }), shallowEqual)

    const dispatch = useDispatch()

    const CMS_STATUS = 'CMS.STATUS'

    const category = cmsCategories.find(c => cms.idCategory === c.id) || {}
    const statusChanges = sandreCodes.filter((c) => c.field === CMS_STATUS)

    const [statusChange, setStatusChange] = useState(0)

    const onChangeStatus = () => {
        switch (statusChange) {
            case 1:
                dispatch(CmsAction.updateCMSEvent({ ...cms, status: STATUS.PUBLISHED, sendMail: true, sendNotif: true }, false)).then(() => setIsOpen(false))
                break
            case 2:
                dispatch(CmsAction.updateCMSEvent({ ...cms, status: STATUS.DRAFTED }, false)).then(() => setIsOpen(false))
                break
            case 3:
                dispatch(CmsAction.updateCMSEvent({ ...cms, status: STATUS.ARCHIVED, dateFin: moment().valueOf(), dontGenerateNewsletter: true }, false)).then(() => setIsOpen(false))
                break
            default:
                dispatch(ToastrAction.error(i18n.pleaseChooseStatus))
        }
    }

    return (
        <Dialog
            onClose={() => setIsOpen(false)}
            fullWidth
            maxWidth='md'
            open={isOpen}
        >
            <DefaultDialogTitle title={(
                <Grid container sx={{ alignItems: 'center' }} spacing={1}>
                    <img src={getCmsMarker(cms, category)} style={{ height: '3rem' }} />
                    <h5>{cms.title}</h5>
                </Grid>
            )}
            onClose={() => setIsOpen(false)}
            />
            <DialogContent>
                <Grid container spacing={1}>
                    <Grid container direction='column' size={7}>
                        <Grid container>
                            <Typography fontWeight='bold'>{i18n.startDate} : </Typography>{getFullDate(cms.dateDebut)}
                        </Grid>
                        {cms.dateFin && (
                            <Grid container>
                                <Typography fontWeight='bold'>{i18n.endDate} : </Typography>{getFullDate(cms.dateFin)}
                            </Grid>
                        )}
                        {cms.subtitle && (
                            <Grid container>
                                <Typography fontWeight='bold'>{i18n.subTitle} : </Typography>{cms.subtitle}
                            </Grid>
                        )}
                        {cms.author && (
                            <Grid container>
                                <Typography fontWeight='bold'>{i18n.author} : </Typography>{cms.author}
                            </Grid>
                        )}
                        {cms.comment && (
                            <Grid container>
                                <Typography fontWeight='bold'>{i18n.description} : </Typography><Typography dangerouslySetInnerHTML={{ __html: cms.comment || '' }} />
                            </Grid>
                        )}
                        {cms.link && (
                            <Grid container>
                                <Typography fontWeight='bold'>{i18n.link} : </Typography>{cms.link}
                            </Grid>
                        )}
                    </Grid>
                    <Grid size={5}>
                        <CartographyPanel
                            layers={['STATIONS_POINTS']}
                            componentType='all'
                            fullScreenable={false}
                            stationsPoints={[{ ...cms, projection: 16, typeName: 'cms', markerIcon: getCmsMarker(cms, category) }]}
                            noPanels
                            noMarkerTooltip
                            height={300}
                        />
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions sx={{ justifyContent: 'space-between' }}>
                <Grid size={2}>
                    {
                        accountUser.isAdmin === '1' && (
                            <Button
                                onClick={() => {
                                    setConfirmationModal(() => {
                                        dispatch(CmsAction.deleteCMSEvent(cms, false))
                                    })
                                    setIsOpen(false)
                                }}
                                variant='outlined'
                            >
                                {i18n.delete}
                            </Button>
                        )
                    }
                </Grid>
                <Grid size={7}>
                    {
                        (accountUser.isAdmin === '1' && cms.status === STATUS.DRAFTED) && (
                            <Grid spacing={2} container alignItems='center'>
                                <Button variant='contained' onClick={() => onChangeStatus()}>
                                    {i18n.changeStatusInto}
                                </Button>
                                <Grid sx={{ marginBottom: 1 }}>
                                    <Select
                                        onChange={newStatusChange => setStatusChange(newStatusChange)}
                                        value={statusChange}
                                        options={statusChanges}
                                        keyValue='code'
                                        keyLabel='name'
                                    />
                                </Grid>
                            </Grid>
                        )
                    }
                </Grid>
                <Grid size={3}>
                    <Button variant='contained' onClick={() => dispatch(push(`/contents/${cms.idCategory}/${cms.id}`))}>
                        {i18n.accessToTheFile}
                    </Button>
                </Grid>
            </DialogActions>
        </Dialog>
    )
}

AlertCmsModal.propTypes = {
    cmsCategories: PropTypes.arrayOf(PropTypes.instanceOf(CMSCategoryDto)),
    cms: PropTypes.instanceOf(PropTypes.instanceOf(CMSEventDto)),
    isOpen: PropTypes.bool,
    setIsOpen: PropTypes.func,
}

const mapStateToProps = store => ({
    cmsCategories: store.EventsReducer.cmsCategories,
})

export default connect(mapStateToProps)(AlertCmsModal)